export default __webpack_public_path__ + "static/dealer2-d208e3004d8f00b33a2bab017d53113f.svg";